import HundredBricksAPIError from '../../HundredBricksAPIError';
class RebatesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RebatesError', ...args);
    }
}
export default RebatesError;
